@for (item of items; track item.label) {
  <div class="legend-item">
    <span class="legend-swatch" [style.background-color]="item.colorVar"></span>
    <cs-label class="legend-label">{{ item.label }}</cs-label>
  </div>
}
<div class="legend-item">
  <span class="legend-dash"></span>
  <cs-label class="legend-label">{{ LL.progress.trendLegend.mayChange() }}</cs-label>
</div>
